import { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSidebar } from '../contexts/SidebarContext';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import ThemeSelect from './ThemeSelect';

export default function Header() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const { isSidebarOpen, setIsSidebarOpen } = useSidebar();

  const closeSidebar = useCallback(() => setIsSidebarOpen(false), [setIsSidebarOpen]);
  const handleLogout = async () => {
    try {
      const { error } = await signOut();
      if (error) {
        console.error('Logout error:', error);
      }
      // Navigate to login regardless of error to ensure user is logged out from UI
      navigate('/login');
    } catch (err) {
      console.error('Logout exception:', err);
      navigate('/login');
    }
  };

  if (!user) return null;

  return (
    <>
      <Sidebar 
        isOpen={isSidebarOpen} 
        onClose={closeSidebar}
        onLogout={handleLogout}
      />
      
      <header className={`workspace-header bg-white text-slate-700 border-b border-slate-200 fixed top-0 left-0 right-0 z-30 transition-all duration-300 ${
        isSidebarOpen ? 'xl:ml-64' : 'ml-0'
      }`}>
        <div className="w-full px-3 sm:px-6">
          <div className="flex items-center h-16">
            <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} aria-label={isSidebarOpen ? 'Contraer navegación' : 'Abrir navegación'} aria-expanded={isSidebarOpen} aria-controls="workspace-navigation" className="mr-2 sm:mr-4 rounded-lg p-2 hover:bg-slate-100">
              <Menu className="h-5 w-5" />
            </button>
            
            <Link to="/" className="font-medium text-sm">
              Gestión documental
            </Link>

            <ThemeSelect />
          </div>
        </div>
      </header>
    </>
  );
}